<template>
  <form novalidate @submit.prevent="submit">
    <v-menu
      v-model="dateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formData.date"
          v-validate="'required'"
          :error-messages="errors.collect('Date')"
          label="Choose Date"
          data-vv-name="Date"
          required
          prepend-icon="mdi-calendar-outline"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="formData.date"
        :min="today"
        @input="dateMenu = false"></v-date-picker>
    </v-menu>
    <v-text-field
      v-model="formData.title"
      v-validate="'required|min:10'"
      :error-messages="errors.collect('Title')"
      label="Title"
      prepend-icon="mdi-message-outline"
      data-vv-name="Title"
      required autofocus
    ></v-text-field>
    <v-textarea
      v-model="formData.desc"
      label="Message"
      prepend-icon="mdi-message-outline"
    ></v-textarea>
    <pre>extraData {{ extraData }}</pre>
    <pre>formData {{ formData }}</pre>
    <div class="mt-5 d-flex">
      <v-spacer></v-spacer>
      <span v-if="!saving">
        <v-btn depressed text type="reset" @click="close">Cancel</v-btn>
        <v-btn depressed color="accent" class="ml-2" type="submit">Save</v-btn>
      </span>
      <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
        <v-progress-circular indeterminate size="12" width="1" class="mr-1"></v-progress-circular>
        <span>Saving...</span>
      </v-btn>
    </div>
  </form>
</template>
<script>
import { mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'project-milestone-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    extraData: {
      default() {
        return {};
      },
    },
    formData: {
      type: Object,
      default() {
        return {
          date: new Date().toISOString().slice(0, 10),
          desc: '',
        };
      },
    },
  },

  data: () => ({
    today: new Date().toISOString().slice(0, 10),
    dateMenu: false,
    autofocus: true,
    saving: false,
    dictionary: {
      attributes: {
        milestoneName: 'Issue Name',
      },
    },
  }),

  computed: {
    endpoint() {
      return this.formData.id ? 'updateIssue' : 'addIssue';
    },
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.autofocus = true;
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true;
          const payload = {
            ...this.formData,
            ...this.extraData,
          };
          this[this.endpoint](payload).then(
            () => {
              this.$emit('save', payload);
            },
          ).catch(() => {}).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    close() {
      this.$emit('close');
    },
    clear() {
      this.$validator.reset();
    },
    ...mapActions('db', {
      addIssue: types.CREATE_ISSUE,
      updateIssue: types.UPDATE_ISSUE,
    }),
  },
};
</script>
